
<div class="page_not_found d-flex align-items-center justify-content-center flex-column">
    <h2 class="h1">
        404
    </h2>
    <span *ngIf="dir === 'ltr'">Page Not Found</span>
    <span *ngIf="dir === 'rtl'">الصفحة غير موجودة</span>
</div>